<template>
  <v-text-field
    v-model="item"
    maxlength="7"    
    placeholder="Ex:. ABC1A23"
    label="Placa"
    outlined
    dense
    @input="$emit('input', item)"
  />
</template>

<script>
  import orderTypeService from '@/services/tipo-pedido.service';

  export default {
    name: 'SearchOrderVehiclePlateField',

    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data: () => ({  
      item: null     
    }),

    mounted() {
      this.item = this.value;      
    }
  };
</script>
